import { Link } from 'react-router';
import { formatDate, STAFF_ROLE_LABEL } from '@reikraft/shared';
import { Empty, ErrorBox, Loader, Notice, Panel } from '@reikraft/ui';
import { PageHead, useStaff } from '../components/common';
import { useFlag } from '../session';

export function MastersPage() {
  const on = useFlag('masters');
  const staff = useStaff();
  if (!on) return <Notice label="Раздел выключен">Включите «Мастера» в настройках, чтобы назначать мастеров на заказы.</Notice>;
  if (staff.isLoading) return <Loader />;
  if (staff.isError) return <ErrorBox error={staff.error} />;
  const list = (staff.data ?? []).filter((s) => s.isActive);
  return (
    <>
      <PageHead
        title="Мастера"
        sub="Загрузка по активным заказам: приёмка, диагностика, согласование, ремонт, стенд"
        actions={
          <Link to="/settings?tab=users" className="rk-btn">
            Сотрудники
          </Link>
        }
      />
      <Panel bodyless>
        <div className="rk-rows">
          {list.map((s) => (
            <div key={s.id} className="rk-row" style={{ padding: '14px 18px', justifyContent: 'space-between' }}>
              <span className="rk-td--stack">
                <b>{s.name}</b>
                <span className="rk-muted" style={{ fontSize: 12 }}>
                  {STAFF_ROLE_LABEL[s.role]} · {s.lastLoginAt ? `входил ${formatDate(s.lastLoginAt)}` : 'не входил'}
                </span>
              </span>
              <span className="rk-row" style={{ ['--rk-gap' as string]: '10px' }}>
                <span className="rk-label">В работе</span>
                <b className="rk-display" style={{ fontSize: 24 }}>
                  {s.activeOrders}
                </b>
              </span>
            </div>
          ))}
          {!list.length && <Empty>Сотрудников нет</Empty>}
        </div>
      </Panel>
    </>
  );
}
